export interface Practice {
  id: string;
  guid: string;
  name: string;
  logo: string;
  big_logo: string;
  address: string;
  phone: string;
  email: string;
  latitude: string;
  longitude: string;
  availability: string;
  direct_email: string;
  www_url: string;
  fb_url: string;
  yelp_url: string;
  google_url: string;
  foursquare_url: string;
  fb_review_url: string;
  yelp_review_url: string;
  app_url: string;
  patient_portal: string;
  late_cancel_fee: string;
  membership_url: string;
  connect_team_chat?: boolean;
  has_active_subscription: boolean;
  extra_sms_full_operator?: string;
  extra_sms_full_number?: string;
}

export interface PracticeList {
  eng_id?: string;
  eng_guid?: string;
  analytics_id?: string;
  name: string;
}

export enum PracticeType {
  ENGAGEMENT = 'Engagement',
  ANALYTICS = 'Analytics',
  BUNDLED = 'Bundled'
}

export interface BasePractice {
  id: string;
  guid: string;
  name: string;
  type: PracticeType.ANALYTICS | PracticeType.BUNDLED | PracticeType.ENGAGEMENT;
}

export interface AnalyticsPractice extends BasePractice {
  type: PracticeType.ANALYTICS;
}

export interface BundledPractice extends BasePractice {
  analyticsGuid: string;
  engagementId: string;
  type: PracticeType.BUNDLED;
}

export interface EngagementPractice extends BasePractice {
  type: PracticeType.ENGAGEMENT;
}

export type PracticeInfo =
  | AnalyticsPractice
  | BundledPractice
  | EngagementPractice;
